import { environment } from "src/environments/environment";

const baseAPIUrl : any = environment.uatLoginCommonUrl;

export const iframeUrl = {
    activationPendingUsers: {
        url : baseAPIUrl+'view/activation-pending-users/511EBFAC-7BA4-4C41-92BD-2D26028F1578'
    },
    useractivate : {
        url :baseAPIUrl+'auth/useractivate/'
    },
    userSearch : {
        url : baseAPIUrl+'view/view-all-administration/E7D8D4F8-A0D9-4A45-AD08-139902309503'
    },
    entitySearch:{
        url : baseAPIUrl+'view/view-all-administration/F25A23BE-A48F-4179-842D-FE3FAF0CB83D'
    },
    createUser:{
        url : baseAPIUrl+'transaction/submit/845E10F6-84FD-4E3B-9D72-588152C623D5'
    },
    createBroker : {
        url : baseAPIUrl+'transaction/submit/E183647F-C90F-48F2-9C8E-8C2458D867F3'
    },
    createAgent : {
        url : baseAPIUrl+'transaction/submit/E4CC9F86-FBE2-42B9-B6CD-34F2DC184E17'
    },
    createBranch : {
        url : baseAPIUrl+'transaction/submit/ADBC294C-BF4C-47C4-B9F7-D2181CE04D0E'
    },
    myProfile : {
        url : baseAPIUrl+'view/my-profile'
    }
};
  